module.exports = __webpack_public_path__ + "static/favicon-5d56a223a1eca5fcc5cb86e1584a30ef.ico";